module.exports = __webpack_public_path__ + "static/media/zipcodes_final.299feebf.geojson";